import WriteDirectionEnum from '@inter-ikea-kompis/enums/lib/WriteDirectionEnum';
import { useKompis } from '../contexts';
/**
 * Determines if right to left is enabled for the current locale.
 *
 * @returns If right to left is enabled.
 */
const useIsRtl = () => {
    const { dexfAppSettings: { localisation: { writeDirection } } } = useKompis();
    return writeDirection === WriteDirectionEnum.rtl.toString();
};
export default useIsRtl;
//# sourceMappingURL=useIsRtl.js.map